<template>
  <div
    style="padding: 20px; height: 100%; flex-direction: column"
    class="between"
  >
    <div style="width: 100%">
      <div
        style="
          font-weight: 500;
          font-size: 16px;
          color: #1d2129;
          line-height: 20px;
          padding-bottom: 18px;
          border-bottom: 1px solid #f3f5f8;
        "
      >
        解决方案配置
      </div>
      <div style="padding: 20px 0 6px">
        <el-form
          ref="form"
          :model="form"
          label-width="70px"
          label-position="left"
        >
          <el-row :gutter="10">
            <el-col :span="5">
              <el-form-item label="解决方案名称" label-width="100px">
                <el-input v-model="form.title" clearable></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="7">
              <el-form-item label="创建时间">
                <el-date-picker
                  v-model="form.created"
                  type="daterange"
                  range-separator="——"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  clearable
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 100%"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>

            <el-col :span="2">
              <div
                style="
                  width: 70px;
                  height: 32px;
                  background: #107fff;
                  border-radius: 4px;
                  font-size: 16px;
                  color: #ffffff;
                  line-height: 20px;
                  letter-spacing: 2px;
                  cursor: pointer;
                  user-select: none;
                "
                class="center"
                @click="getList"
              >
                查询
              </div>
            </el-col>
          </el-row>
        </el-form>
        <div
          style="
            width: 82px;
            height: 32px;
            background: #107fff;
            border-radius: 4px;
            font-size: 14px;
            color: #ffffff;
            line-height: 20px;
            cursor: pointer;
            user-select: none;
            gap: 8px;
            margin-bottom: 10px;
          "
          class="center"
          @click="drawer = true"
        >
          <i class="el-icon-plus"></i>
          新增
        </div>
      </div>
    </div>
    <div style="flex: 1; height: 100%; width: 100%">
      <el-table
        :data="data"
        style="width: 100%"
        border
        :header-cell-style="headerCellStyle"
        height="100%"
      >
        <el-table-column
          label="解决方案名称"
          width="135"
          
          prop="title"
        >
        </el-table-column>
        <el-table-column label="模板名称" width="135" >
          <template #default="{ row }">
            <div>{{ row.template?.name }}</div>
          </template>
        </el-table-column>
        <el-table-column label="客户痛点" >
          <el-table-column label="标题" width="135" >
            <template #default="{ row }">
              <div v-for="(item, index) in row.painPoints" :key="index">
                {{ item.title }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="描述" width="135" >
            <template #default="{ row }">
              <div v-for="(item, index) in row.painPoints" :key="index">
                {{ item.description }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="图片" width="135" >
            <template #default="{ row }">
              <img
                :src="item.icon"
                v-for="(item, index) in row.painPoints"
                :key="index"
                style="width: 50px; height: 50px"
              />
            </template>
          </el-table-column>
        </el-table-column>

        <el-table-column label="解决方案" >
          <el-table-column label="标题" width="135" >
            <template #default="{ row }">
              <div v-for="(item, index) in row.solutions" :key="index">
                {{ item.title }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="描述" width="135" >
            <template #default="{ row }">
              <div v-for="(item, index) in row.solutions" :key="index">
                {{ item.description }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="图片" width="135" >
            <template #default="{ row }">
              <img
                :src="item.icon"
                v-for="(item, index) in row.solutions"
                :key="index"
                style="width: 50px; height: 50px"
              />
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="业务价值" >
          <el-table-column label="标题" width="135" >
            <template #default="{ row }">
              <div v-for="(item, index) in row.businessValues" :key="index">
                {{ item.title }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="描述" width="135" >
            <template #default="{ row }">
              <div v-for="(item, index) in row.businessValues" :key="index">
                {{ item.description }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="图片" width="135" >
            <template #default="{ row }">
              <img
                :src="item.icon"
                v-for="(item, index) in row.businessValues"
                style="width: 50px; height: 50px"
                :key="index"
              />
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column
          prop="created"
          label="创建时间"
          width="160"
          
        >
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="100">
          <template #default="{ row }">
            <el-button type="text" @click="handleEdit(row)">编辑</el-button>
            <el-button
              type="text"
              style="color: #ff4f4f"
              @click="handleDelete(row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div
      style="
        display: flex;
        align-items: center;
        justify-content: flex-end;
        width: 100%;
        margin-top: 9px;
      "
    >
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        :current-page="form.pageNumber"
        layout="total, sizes, prev, pager, next"
        :total="total"
      >
      </el-pagination>
    </div>

    <el-dialog
      title="模板配置"
      :visible.sync="drawer"
      :before-close="drawerClose"
      width="540px"
      :close-on-click-modal="false"
      top="6vh"
    >
      <div
        class="between"
        style="flex-direction: column; height: 100%; width: 100%"
      >
        <div class="content">
          <el-form ref="editFormRef" :model="editForm" label-position="top">
            <el-form-item label="解决方案名称">
              <el-input v-model="editForm.title"></el-input>
            </el-form-item>
            <el-form-item label="关联模板">
              <el-select
                v-model="editForm.templateId"
                placeholder="请选择关联模板"
                filterable
                clearable
              >
                <el-option
                  v-for="item in templates"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="客户痛点">
              <el-table :data="editForm.painPoints" style="width: 100%" border>
                <el-table-column prop="title" label="名称" width="width">
                  <template #default="{ row }">
                    <el-input v-model="row.title"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="description" label="描述" width="230px">
                  <template #default="{ row }">
                    <el-select
                      v-model="row.description"
                      multiple
                      filterable
                      allow-create
                      default-first-option
                    >
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column prop="icon" label="图片">
                  <template #default="{ row, $index }">
                    <el-upload
                      class="uploader"
                      :action="url"
                      ref="uploadRef"
                      :on-success="
                        (response) =>
                          handleSuccess(response, 'painPoints', $index)
                      "
                      :show-file-list="false"
                      :headers="{
                        Authorization: `Bearer ${$store.getters.token}`,
                      }"
                    >
                      <img v-if="row.icon" :src="row.icon" class="avatar" />
                      <i v-else class="el-icon-plus uploader-icon"></i>
                    </el-upload>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="60px" >
                  <template #default="{ $index }">
                    <i
                      class="el-icon-delete"
                      style="cursor: pointer"
                      @click="handleDeleteTable($index, 'painPoints')"
                    ></i>
                  </template>
                </el-table-column>
              </el-table>
              <div
                style="
                  width: 82px;
                  height: 32px;
                  background: #107fff;
                  border-radius: 4px;
                  font-size: 14px;
                  color: #ffffff;
                  line-height: 20px;
                  cursor: pointer;
                  user-select: none;
                  gap: 8px;
                  margin-bottom: 10px;
                  margin-top: 10px;
                "
                class="center"
                @click="handleAddTable('painPoints')"
              >
                <i class="el-icon-plus"></i>
                新增
              </div>
            </el-form-item>

            <el-form-item label="解决方案">
              <el-table :data="editForm.solutions" style="width: 100%" border>
                <el-table-column prop="title" label="名称" width="width">
                  <template #default="{ row }">
                    <el-input v-model="row.title"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="description" label="描述" width="230px">
                  <template #default="{ row }">
                    <el-select
                      v-model="row.description"
                      multiple
                      filterable
                      allow-create
                      default-first-option
                    >
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column prop="icon" label="图片">
                  <template #default="{ row, $index }">
                    <el-upload
                      class="uploader"
                      :action="url"
                      ref="uploadRef"
                      :on-success="
                        (response) =>
                          handleSuccess(response, 'solutions', $index)
                      "
                      :show-file-list="false"
                      :headers="{
                        Authorization: `Bearer ${$store.getters.token}`,
                      }"
                    >
                      <img v-if="row.icon" :src="row.icon" class="avatar" />
                      <i v-else class="el-icon-plus uploader-icon"></i>
                    </el-upload>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="60px" >
                  <template #default="{ $index }">
                    <i
                      class="el-icon-delete"
                      style="cursor: pointer"
                      @click="handleDeleteTable($index, 'solutions')"
                    ></i>
                  </template>
                </el-table-column>
              </el-table>
              <div
                style="
                  width: 82px;
                  height: 32px;
                  background: #107fff;
                  border-radius: 4px;
                  font-size: 14px;
                  color: #ffffff;
                  line-height: 20px;
                  cursor: pointer;
                  user-select: none;
                  gap: 8px;
                  margin-bottom: 10px;
                  margin-top: 10px;
                "
                class="center"
                @click="handleAddTable('solutions')"
              >
                <i class="el-icon-plus"></i>
                新增
              </div>
            </el-form-item>
            <el-form-item label="业务价值">
              <el-table
                :data="editForm.businessValues"
                style="width: 100%"
                border
              >
                <el-table-column prop="title" label="名称" width="width">
                  <template #default="{ row }">
                    <el-input v-model="row.title"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="description" label="描述" width="230px">
                  <template #default="{ row }">
                    <el-select
                      v-model="row.description"
                      multiple
                      filterable
                      allow-create
                      default-first-option
                    >
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column prop="icon" label="图片">
                  <template #default="{ row, $index }">
                    <el-upload
                      class="uploader"
                      :action="url"
                      ref="uploadRef"
                      :on-success="
                        (response) =>
                          handleSuccess(response, 'businessValues', $index)
                      "
                      :show-file-list="false"
                      :headers="{
                        Authorization: `Bearer ${$store.getters.token}`,
                      }"
                    >
                      <img v-if="row.icon" :src="row.icon" class="avatar" />
                      <i v-else class="el-icon-plus uploader-icon"></i>
                    </el-upload>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="60px" >
                  <template #default="{ $index }">
                    <i
                      class="el-icon-delete"
                      style="cursor: pointer"
                      @click="handleDeleteTable($index, 'businessValues')"
                    ></i>
                  </template>
                </el-table-column>
              </el-table>
              <div
                style="
                  width: 82px;
                  height: 32px;
                  background: #107fff;
                  border-radius: 4px;
                  font-size: 14px;
                  color: #ffffff;
                  line-height: 20px;
                  cursor: pointer;
                  user-select: none;
                  gap: 8px;
                  margin-bottom: 10px;
                  margin-top: 10px;
                "
                class="center"
                @click="handleAddTable('businessValues')"
              >
                <i class="el-icon-plus"></i>
                新增
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="drawerClose">取消</el-button>
        <el-button type="primary" @click="handleSave">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getSolutionPage,
  templatePage,
  deleteSolution,
  addOrUpdateSolution,
} from "@/api/module";
import { headerCellStyle } from "@/utils/CustomUtil.js";
export default {
  data() {
    return {
      drawer: false,
      form: {
        pageSize: 10,
        pageNumber: 1,
      },
      editForm: {
        painPoints: [],
        businessValues: [],
        solutions: [],
        solutionOverview: {
          description: "",
          image: "",
        },
      },
      data: [],
      total: 0,
      url: `${process.env.VUE_APP_BASE_URL}/cloud-admin/file/upload?type=0`,
      templates: [],
    };
  },
  methods: {
    handleSuccess(response, type, index) {
      this.$set(this.editForm[type][index], "icon", response.data);
    },
    handleDeleteTable(index, type) {
      if (type === "painPoints") {
        this.editForm.painPoints.splice(index, 1);
      } else if (type === "solutions") {
        this.editForm.solutions.splice(index, 1);
      } else if (type === "tags") {
        this.editForm.businessValues.splice(index, 1);
      }
    },
    handleAddTable(type) {
      if (type === "painPoints") {
        this.editForm.painPoints.push({});
      } else if (type === "solutions") {
        this.editForm.solutions.push({});
      } else {
        this.editForm.businessValues.push({});
      }
    },
    handleSave() {
      this.$refs.editFormRef.validate((valid) => {
        if (valid) {
          console.log(this.editForm);
          addOrUpdateSolution(this.editForm).then((res) => {
            console.log(res);
            this.$message.success("保存成功");
            this.drawerClose();
            this.getList();
          });
        } else {
          return false;
        }
      });
    },
    success(response) {
      this.$set(this.editForm, "icon", response.data);
    },
    drawerClose() {
      this.editForm = {
        painPoints: [],
        businessValues: [],
        solutions: [],
        solutionOverview: {
          description: "",
          image: "",
        },
      };
      this.drawer = false;
    },
    headerCellStyle,
    async getList() {
      const res = await getSolutionPage(this.form);
      this.data = res.data.records;
      this.total = res.data.total;
    },
    handleSizeChange(val) {
      if (!this.total) return;
      this.form.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      if (!this.total) return;
      this.form.pageNumber = val;
      this.getList();
    },
    handleEdit(row) {
      console.log(row);
      this.editForm = { ...row, templateId: row.template.id };
      this.drawer = true;
    },
    async handleDelete(row) {
      await deleteSolution(row.id);
      this.$message.success("删除成功");
      this.getList();
    },
  },
  mounted() {
    this.getList();
    templatePage({
      pageSize: 999,
      pageNumber: 1,
    }).then((res) => {
      this.templates = res.data.records;
    });
  },
};
</script>

<style scoped lang="less">
/deep/.el-form-item__content {
  line-height: 32px;
}
/deep/.el-input__inner {
  height: 32px;
  line-height: 32px;
}

/deep/.el-form-item__label {
  line-height: 32px;
}
/deep/.el-date-editor .el-range__icon {
  line-height: 24px;
}
/deep/.el-date-editor .el-range-separator {
  line-height: 22px;
}
/deep/.el-input__icon {
  line-height: 32px;
}
/deep/.el-date-editor .el-range__close-icon {
  line-height: 24px;
}

/deep/.el-date-editor .el-range-separator {
  color: #bfbfbf;
}
.header {
  height: 60px;
  padding: 20px;
  border-bottom: 1px solid #ebecee;
  width: 100%;
  span {
    font-weight: 500;
    font-size: 16px;
    color: #1d2129;
    line-height: 20px;
  }
  .el-icon-close {
    cursor: pointer;
  }
}

.content {
  width: 100%;
  .el-select {
    width: 100%;
  }
}

.footer {
  height: 66px;
  border-top: 1px solid #ebecee;
  width: 100%;
  padding-left: 20px;
}

.uploader /deep/.el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.uploader .el-upload:hover {
  border-color: #409eff;
}
.uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 40px;
  height: 40px;
  line-height: 40px;
  text-align: center;
}
.avatar {
  width: 40px;
  height: 40px;
  display: block;
}

/deep/.el-dialog__body {
  height: 69vh;
  overflow: auto;
}
</style>